import { KeyBase, IHasKey } from '@kpd/framework-ngx';

// Base class for components using a p-table with kpd directives to handle selection
// Implements methods for selecting the next/previous row which can be used with keyboard shortcuts
export abstract class TableController {
  items: IHasKey[];
  index: number;
  selectedKeys: KeyBase[] = [];

  onSelectionChanged(event: { index: number; selection: KeyBase[] }): void {
    this.selectedKeys = event.selection;
    this.index = event.index;
  }

  onPrevious(): void {
    const firstSelected = [...this.selectedKeys].shift();
    this.selectRelativeTo(firstSelected, -1);
  }

  onNext(): void {
    const lastSelected = [...this.selectedKeys].pop();
    this.selectRelativeTo(lastSelected, 1);
  }

  private selectRelativeTo(selected: KeyBase | undefined, position: number): void {
    if (!selected) {
      return;
    }
    const user = this.items.find(usr => usr.key.toString() === selected.toString());
    if (!user) {
      return;
    }
    const previous = this.items[this.items.indexOf(user) + position];
    if (previous) {
      this.selectedKeys = [previous.key];
      this.index = this.index + position;
    }
  }
}
